import React from 'react';
import { Hero } from '../components/home/Hero';
import { BuiltWith } from '../components/home/BuiltWith';
import { SelectedWork } from '../components/home/SelectedWork';
import { WhatWeDo } from '../components/home/WhatWeDo';
import { Process } from '../components/home/Process';
import { NumbersStrip } from '../components/home/NumbersStrip';
import { TestimonialSection } from '../components/home/TestimonialSection';
import { PricingTeaser } from '../components/home/PricingTeaser';
import { FaqSection } from '../components/home/FaqSection';
import { CtaBand } from '../components/home/CtaBand';
type HeroVariant = 'overlap' | 'stacked' | 'editorial';
interface HomeProps {
  heroVariant?: HeroVariant;
}
export function Home({
  heroVariant = 'overlap'
}: HomeProps) {
  return <>
      <Hero variant={heroVariant} data-id="element-991" data-mp="3kvk5aj0nqz5g" />
      <BuiltWith data-id="element-992" data-mp="3kuii5g6dam7d" />
      <SelectedWork data-id="element-993" data-mp="3kv0nd2b0carf" />
      <WhatWeDo data-id="element-994" data-mp="3kxmsywec8g70" />
      <Process data-id="element-995" data-mp="3owlus84rvwu8" />
      <NumbersStrip data-id="element-996" data-mp="3ow42tnp584s4" />
      <TestimonialSection data-id="element-997" data-mp="3ovkjc2juh8bz" />
      <PricingTeaser data-id="element-998" data-mp="3oyyo1hfzdtml" />
      <FaqSection data-id="element-999" data-mp="30wrnkc0kxpdf" />
      <CtaBand data-id="element-1000" data-mp="30xb7tzdpcpum" />
    </>;
}